import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const REQUESTED_FEATURES = 'REQUESTED_FEATURES';
export const RECEIVED_FEATURES = 'RECEIVED_FEATURES';
export const REQUEST_FEATURES_FAILED = 'REQUEST_FEATURES_FAILED';

const getFeatures = () => (
  (dispatch) => {
    dispatch({
      type: REQUESTED_FEATURES,
    });

    return axios.get('/api/features')
      .then((response) => {
        dispatch({
          type: RECEIVED_FEATURES,
          data: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: REQUEST_FEATURES_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to fetch information about activated features',
          originalError: error,
        }));
      });
  }
);

export default getFeatures;
